import {
  GET_SHIP_OPTION_LIST_SUCCESS,
  SET_SHIP_OPTION_DATA_LOADING
} from 'store/ducks/shipOption/types';
import {
  CONFIGURE_CHECKOUT_SUCCESS
} from 'store/ducks/checkout/types';

const defaultState = {
  savedShipOptions: [],
  isLoading: false,
  isLoaded: false,
  hasNextWow: false
};

export default function shipOptions(state = defaultState, action = {}) {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case CONFIGURE_CHECKOUT_SUCCESS: {
      const { deliveryOptions } = payload;

      if (deliveryOptions) {
        return addSavedShipOptionsToState(state, deliveryOptions);
      }

      return state;
    }

    case GET_SHIP_OPTION_LIST_SUCCESS: {
      return addSavedShipOptionsToState(state, payload);
    }

    case SET_SHIP_OPTION_DATA_LOADING: {
      return { ...state, isLoading: payload };
    }

    default: {
      return state;
    }
  }
}

const addSavedShipOptionsToState = (state, payload) => {
  const { groupDeliveryOptions: { lineItemDeliveryOptions, orderDeliveryOptions } } = payload;
  let savedShipOptions = orderDeliveryOptions;

  if (!orderDeliveryOptions.length) {
    const options = lineItemDeliveryOptions.find(item => item.deliveryOptions.length) || { deliveryOptions: [] };
    savedShipOptions = options.deliveryOptions;
  }
  return { ...state, savedShipOptions, lineItemDeliveryOptions, hasNextWow: checkForNextWow(savedShipOptions), isLoaded: true, isLoading: false };
};

export const checkForNextWow = savedShipOptions => !!savedShipOptions?.find(item => item.name === 'next-wow');
